export default {


 
    transfer: {
        current_step: 1,
        people:1,
        trip: null,
        ar: false,
        date_a: null,
        date_r: null,
        datemin: new Date().toISOString(),
        time_a: null,
        time_r: null,
        from: null,
        from_items:[],
        to: null,
        to_items:[],
        extras:[],
        first_name: null,
        last_name: null,
        phone: null,
        notes: null,
        status: "wait",
        price: null,
        totalprice: null
    },
    isBookSaving:false,
    /*
    *  door to door
    */
    isDoorToDoorLoading: true,
    isDoorToDoorLoadingAdd: true,
    doorToDoorList: null,
    doorToDoorTrip: null,
    doorToDoorStop: null,
    /*
    *  Services
    */
    isLocalBusLoading: true,
    localBusList: null,
    localbus: {
        stops: []
    },
    /*
    *  Services
    */
    isServicesLoading: true,
    servicesList: null

}